import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
  IMPORT_MARKETPLACE_SUMMARY,
  IMPORT_LOGS,
  MARKETPLACE_SUMMARY, MARKETPLACE_SUMMARY_FIELDS, MARKETPLACE_SUMMARY_PAGES,
  VIEW_IMPORTED_FILES,
} from './constants';
import { Layout } from "../../global/Table/TablePageHelpers/LayoutObject";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableCell,
} from '@mui/material';
import TablePage from "../../global/Table/TablePage";
import '../shippingSummary/ShippingSummary.css';
import {HourglassEmptyTwoTone} from "@material-ui/icons";
import { Upload } from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ImportMarketplacePopper from './ImportMarketplacePopper';
import LinearProgressWithLabel from '../../../pages/Dashboard/LinearProgressWithLabel';
import RefreshIcon from '@material-ui/icons/Refresh';
import Utils from '../../Utils/Utils';
import MapIcon from '@material-ui/icons/Map';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import ImportLogsDrawer from './ImportLogsDrawer';

// List of column IDs
const MARKETPLACE_COLUMNS = [
  'amazon_ca', 'amazon_com', 'walmart_ca', 'walmart_com',
  'ebay_ca', 'exponet_ca', 'exponet_us', 'customer_ca'
];

// Section header rows rendered above the summary row they group
const SECTION_HEADERS = [
  { beforeRow: 'Product Sales (Seller Fulfilled)', name: 'Sales' },
  { beforeRow: 'Net Tax Received', name: 'Taxes' },
  { beforeRow: 'Selling Fee', name: 'Expenses' }
];

class MarketplaceSummaryTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          selectedMarketplace: null,
          progress: this.props.progress,
          sessionId: this.props.sessionId,
          uploading: false,
          confirmReimportOpen: false,
          confirmReimportMessage: '',
          pendingImportPayload: null,
          logsDrawerOpen: false,
        };
        this.hiddenMarketplaceInput = React.createRef();
        this.importMarketplace = this.importMarketplace.bind(this);
    }

    getTableHeaders = () => {
      let headers = [];
      headers.push(Layout.columnHead(null, null, null)); // Existing code

      // Conditionally render headers based on selected currency
      const { selectedCurrency } = this.props;

      // Add 'Description' header only once, regardless of currency
      if (selectedCurrency !== "Consolidated CAD" && selectedCurrency !== "Consolidated" ) {
        headers.push(Layout.columnHead('Description', null, 'left'));
      }

      // Filter headers based on selected currency
      const filteredHeaders = MARKETPLACE_SUMMARY_FIELDS.filter((headCell) => {
        if (selectedCurrency === "CAD" && headCell.id.includes("_ca")) {
          return true;
        }
        if (selectedCurrency === "USD" && (headCell.id.includes("_com") || headCell.id.includes("_us"))) {
          return true;
        }
        if (selectedCurrency === "Consolidated") {
          return true; // Show all columns
        }
        if (selectedCurrency === "Consolidated CAD") {
          return true; // Show all columns
        }
        return false;
      });

      // Add filtered headers
      filteredHeaders.forEach((headCell) => {
        headers.push(Layout.columnHead(headCell.label, null, headCell.align));
      });

      return headers;
    };

    formatDollar = (amount) => {
          if (amount === null || amount === undefined) {
              amount = 0;
          }

          if(amount === 0 || amount === "0"){
            return  <div style={{
              padding:'12px'
            }}>

            </div>
          }

          const amountStr = parseFloat(amount).toFixed(2).toString();

          // Check if amountStr is NaN after parsing
          if (isNaN(amountStr)) {
              return '';
          } else {
              return (
                  <div style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '3px',
                      marginRight: '15px',
                      padding:0
                  }}>
                      <span style={{ flexShrink: 0, marginLeft: '16px', marginRight: '16px' }}>$</span>
                      <span style={{ marginLeft: 'auto' }}>
                      {amountStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>
                  </div>
              );
          }
      };

    // Function to determine if a column should be displayed based on the selected currency
    shouldDisplayColumn = (columnId) => {
      const { selectedCurrency } = this.props;

      if (selectedCurrency === "CAD" && columnId.includes("_ca")) {
        return true;
      }
      if (selectedCurrency === "USD" && (columnId.includes("_com") || columnId.includes("_us"))) {
        return true;
      }
      if (selectedCurrency === "Consolidated") {
        return true; // Show all columns
      }
      if (selectedCurrency === "Consolidated CAD") {
        return true; // Show all columns
      }
      return false;
    };

    // Inserts the section header rows (Sales, Taxes, Expenses) above the rows they group
    getTableRows = () => {
      const { marketplaceSummary } = this.props;

      if (!marketplaceSummary || marketplaceSummary.length === 0) {
        return marketplaceSummary;
      }

      const rows = [];
      marketplaceSummary.forEach((row) => {
        const sectionHeader = SECTION_HEADERS.find((header) => header.beforeRow === row?.name);
        if (sectionHeader) {
          rows.push({ name: sectionHeader.name, isSectionHeader: true });
        }
        rows.push(row);
      });

      return rows;
    };

    tableRow = (data) => {
      if (data?.isSectionHeader) {
        // Spans the spacer cell, the description cell and every visible currency column
        const colSpan = 2 + MARKETPLACE_COLUMNS.filter(this.shouldDisplayColumn).length;

        return (
          <TableCell
            colSpan={colSpan}
            style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', textAlign: 'left' }}
          >
            {data.name}
          </TableCell>
        );
      }

      if (!data?.name || data.name === 'Receivables' || data.name === 'Remittance') {
        return null
      }

      const columns = MARKETPLACE_COLUMNS;

      // Check if the row should be bold
      const isBoldRow = [
        'Net Product Sales', 'Income (Gross Sales)', 'Total Expenses', 'Net Income (Net Sales)'
      ].includes(data.name);

      return (
        <React.Fragment>
          <TableCell style={{ width: '16px', height: '55px' }}></TableCell>
          <TableCell style={{ padding: 0, margin: 0, fontWeight: isBoldRow ? 'bold' : 'normal' }}>
            {data.name}
          </TableCell>
          {columns.map((col) =>
              this.shouldDisplayColumn(col) && (
                <TableCell key={col} style={{ fontWeight: isBoldRow ? 'bold' : 'normal' }} className="custom-cell">
                  {this.formatDollar(data[col])}
                </TableCell>
              )
          )}
        </React.Fragment>
      );
    }

    handleExport = () => {
      const { marketplaceSummary } = this.props;
      if (!marketplaceSummary || marketplaceSummary.length === 0) {
        return;
      }

      const filteredSummary = marketplaceSummary.filter(row =>
        row.name !== 'Receivables' && row.name !== 'Remittance'
      );

      if (filteredSummary.length === 0) {
        return;
      }

      // Generate CSV content
      const headers = MARKETPLACE_SUMMARY_FIELDS.map(field => field.label).join(',');
      const rows = filteredSummary.map(row =>
        MARKETPLACE_SUMMARY_FIELDS.map(field => {
          let value = row[field.id] ?? '';
          value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
          return value;
        }).join(',')
      );

      const cleanRows = rows.map(row =>
        row.split(',').map(value => (value.trim() === "0" || value.trim() === "0.00" ) ? '' : value).join(',')
      );


      const csvContent = [headers, ...cleanRows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      // Create and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Marketplace Summary_${this.props.selectedYear}_${this.props.selectedCurrency}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    getMonthsForQuarter = () => {
      const { selectedQuarters } = this.props;

      if (!selectedQuarters) {
        return [
          { name: 'January', value: '01' },
          { name: 'February', value: '02' },
          { name: 'March', value: '03' },
          { name: 'April', value: '04' },
          { name: 'May', value: '05' },
          { name: 'June', value: '06' },
          { name: 'July', value: '07' },
          { name: 'August', value: '08' },
          { name: 'September', value: '09' },
          { name: 'October', value: '10' },
          { name: 'November', value: '11' },
          { name: 'December', value: '12' },
        ]
      } else {
        switch (selectedQuarters) {
          case 1:
            return [  { name: 'January', value: '01' },
              { name: 'February', value: '02' },
              { name: 'March', value: '03' }]
          case 2:
            return [
              { name: 'April', value: '04' },
              { name: 'May', value: '05' },
              { name: 'June', value: '06' }]
          case 3:
            return [
              { name: 'July', value: '07' },
              { name: 'August', value: '08' },
              { name: 'September', value: '09'}]
          case 4:
            return [
              { name: 'October', value: '10' },
              { name: 'November', value: '11' },
              { name: 'December', value: '12' }]
          default:
            return [];
        }
      }
    }

    getContextualMenuItems = () => {
          let menuItems = []

          menuItems.push({
              title: IMPORT_MARKETPLACE_SUMMARY,
              icon: !this.props.processing ? <Upload /> : <HourglassEmptyTwoTone />,
              popper: (
                <ImportMarketplacePopper
                  callback={(selectedMarketplace) =>
                    this.uploadImportMarketplaceFile(selectedMarketplace)
                  }
                />
              ),
          });

        menuItems.push(
          {
          title: 'Refresh',
          icon: <RefreshIcon />,
          onClick: () => {
            // Open the audit preview instead of refreshing directly — the user confirms the
            // recomputed diff before it is committed.
            this.props.onRefresh()
          }
        },
          {
            title: 'Download as CSV',
            icon: <FileDownloadIcon />,
            onClick: () => {
              this.handleExport()
            }
          },
            {
            title: 'Province/State Summary',
            icon: <MapIcon />,
            onClick: () => {
              this.props.setCurrentPage(MARKETPLACE_SUMMARY_PAGES.PROVINCE_SUMMARY)
            }
          },
            {
            title: VIEW_IMPORTED_FILES,
            icon: <DescriptionOutlinedIcon />,
            onClick: () => {
              this.props.setCurrentPage(MARKETPLACE_SUMMARY_PAGES.IMPORTED_FILES)
            }
          },
            {
            title: IMPORT_LOGS,
            icon: <AssignmentLateIcon />,
            onClick: () => {
              this.setState({ logsDrawerOpen: true })
            }
          },

          )

          if (this.props.loadingData) {
              menuItems.push({
                  icon: <HourglassEmptyTwoTone />,
                  handler: () => null,
                  disabled: true,
                  title: "Loading data..."
              });
          }
          return menuItems
      }

    uploadImportMarketplaceFile = (selectedMarketplace) => {
          this.setState({ selectedMarketplace: selectedMarketplace });
          this.hiddenMarketplaceInput.current.click();
      }

    importMarketplace = (e) => {
          if (e.target.files.length === 0) return;
          let file = e.target.files[0];
          let fileReader = new FileReader();
          const inputEl = e.target;

          fileReader.onload = (ev) => {
              let contents = new Uint8Array(ev.target.result);
              const payload = {
                fileType: file.type,
                content: Array.from(contents),
                marketplace: this.state.selectedMarketplace,
                filename: file.name,
              };
              this.setState({ uploading: true });
              this.dispatchMarketplaceImport(payload);
          };
          fileReader.readAsArrayBuffer(file);
          // Reset so re-selecting the same file (e.g. after cancelling the re-import dialog) fires onChange again.
          inputEl.value = null;
      };

    dispatchMarketplaceImport = (payload) => {
          this.props.importMarketplaceSummary(
            payload,
            (status, data) => {
              if (status === 'success') {
                this.props.marketplaceProgressSummary({ sessionId: data }, (status, data, error, successMessage) => {
                  if (status === 'success') {
                    if(successMessage){
                      this.props.customFeedBackBar('success', successMessage)
                    }

                    if(error){
                      this.props.customFeedBackBar('error', error)
                    }

                    this.setState({ progress: data }, () => {
                      this.setState({ selectedMarketplace: null });


                      // Check if progress is 100, then add a delay of 5 seconds
                      if (this.state.progress === 100) {

                        setTimeout(() => {
                          this.setState({ uploading: false,progress: 0 },()=>{
                            this.props.listMarketplaceAPI(true);
                          });
                        }, 2000); // Delay of 2 seconds
                      }
                    });
                  }else{
                    this.setState({ uploading: false });
                    this.setState({ selectedMarketplace: null });
                  }


                });
              } else if (status === 'duplicate') {
                this.setState({
                  uploading: false,
                  confirmReimportOpen: true,
                  confirmReimportMessage: data,
                  pendingImportPayload: payload,
                });
              } else {
                this.setState({ uploading: false });
              }
            }
          );
      };

    handleCancelReimport = () => {
          this.setState({
            confirmReimportOpen: false,
            confirmReimportMessage: '',
            pendingImportPayload: null,
            selectedMarketplace: null,
          });
      };

    handleConfirmReimport = () => {
          const payload = this.state.pendingImportPayload;
          if (!payload) {
            this.handleCancelReimport();
            return;
          }
          this.setState(
            {
              confirmReimportOpen: false,
              confirmReimportMessage: '',
              pendingImportPayload: null,
              uploading: true,
            },
            () => {
              this.dispatchMarketplaceImport({ ...payload, reImport: true });
            }
          );
      };


    searchStrings = (data) => {
      return [data.name]
    }

    render() {

      const currency = ['CAD', 'USD','Consolidated', 'Consolidated CAD']
      const currentYear = new Date().getFullYear()
      const years = Array.from(new Array(currentYear - 2022), (val, index) => 2023 + index)
      const { selectedCurrency, handleCurrencyChange, selectedMonth, handleMonthChange, selectedYear, selectedQuarters, handleYearChange, handleQuarterChange } = this.props


      return (
        <React.Fragment>
          <input
            type="file"
            accept=".zip, .csv"
            ref={this.hiddenMarketplaceInput}
            hidden
            onChange={this.importMarketplace}
          />

          <TopToolbar
            pageName={MARKETPLACE_SUMMARY}
            menuItems={this.getContextualMenuItems()}
          />

          {this.state.uploading && (
            <div
              style={{
                marginLeft: '24px',
                marginTop: '20px',
                marginRight: '24px',
              }}
            >
              <LinearProgressWithLabel
                value={this.state.progress}
                width={'100%'}
              />
            </div>
          )}

          <Box className="box">
            <FormControl variant="outlined" className="form-control">
              <InputLabel id="year-label">Year</InputLabel>
              <Select
                className="select-year"
                labelId="year-label"
                value={selectedYear}
                onChange={handleYearChange}
                label="Year"
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

         <FormControl variant="outlined" className="form-control">
            <InputLabel id="month-label">Month</InputLabel>
            <Select
              className="select-month"
              label="Month"
              labelId="month-label"
              value={selectedMonth || ' '}
              onChange={handleMonthChange}
              displayEmpty
              renderValue={(value) => {
                if (value === ' ') return 'All'
                const month = this.getMonthsForQuarter().find(m => m.value === value)
                return month ? month.name : value
              }}
            >
              <MenuItem value="">All</MenuItem>
              {this.getMonthsForQuarter().map((month) => (
                <MenuItem key={month.value} value={month.value}>
                  {month.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

            <FormControl variant="outlined" className="form-control">
              <InputLabel id="currency-label">Currency</InputLabel>
              <Select
                className="select"
                labelId="currency-label"
                value={selectedCurrency}
                onChange={handleCurrencyChange}
                label="Currency"
              >
                {currency.map((currency) => (
                  <MenuItem key={currency} value={currency}>
                    {currency}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box className="box1-purchase-summary">
            <div className="checkbox-purchase-container">
              <div className="chip-container">
                {['QTR 1', 'QTR 2', 'QTR 3', 'QTR 4'].map((quarter, index) => (
                  <Chip
                    key={index}
                    label={quarter}
                    onClick={() => handleQuarterChange(quarter)}
                    className={`chip ${
                      selectedQuarters === index + 1 ? 'chip-selected' : ''
                    }`}
                  />
                ))}
                <span
                  style={{
                    marginLeft: '10px',
                    paddingTop: '2px',
                  }}
                >
                  {' '}
                  Last updated: {Utils.formatDateTime(
                    this.props.lastUpdatedAt
                  )}{' '}
                </span>
              </div>
            </div>
          </Box>

          <div className="table-page-purchase-summary">
            <TablePage
              type="purchaseSummary"
              tableName="purchaseTable"
              tableRows={this.getTableRows()}
              tableColumnHeads={this.getTableHeaders()}
              tableRow={this.tableRow}
              hasSearchField
              searchStrings={this.searchStrings}
              filters={[]}
            />
          </div>
          <div className="marketplace-divider"></div>

          <Dialog
            open={this.state.confirmReimportOpen}
            onClose={this.handleCancelReimport}
            aria-labelledby="reimport-confirm-title"
            aria-describedby="reimport-confirm-description"
            PaperProps={{
              sx: {
                borderRadius: 2,
                minWidth: 440,
                maxWidth: 520,
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
              },
            }}
          >
            <DialogTitle
              id="reimport-confirm-title"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                pb: 1,
                pt: 2.5,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  bgcolor: 'rgba(0, 94, 115, 0.1)',
                  color: '#005E73',
                  flexShrink: 0,
                }}
              >
                <InfoOutlinedIcon />
              </Box>
              <Box sx={{ fontWeight: 600, fontSize: '1.125rem', color: 'text.primary' }}>
                File already imported
              </Box>
            </DialogTitle>

            <DialogContent sx={{ pt: 1, pb: 1.5 }}>
              <DialogContentText
                id="reimport-confirm-description"
                sx={{ mb: 2, color: 'text.primary', fontSize: '0.95rem' }}
              >
                {this.state.confirmReimportMessage || 'This file has already been imported.'}
              </DialogContentText>

              {this.state.pendingImportPayload?.filename && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.25,
                    px: 1.5,
                    py: 1.25,
                    borderRadius: 1.5,
                    bgcolor: 'rgba(0, 94, 115, 0.04)',
                    border: '1px solid',
                    borderColor: 'rgba(0, 94, 115, 0.15)',
                    mb: 2,
                  }}
                >
                  <InsertDriveFileOutlinedIcon
                    sx={{ color: '#005E73', fontSize: 20, flexShrink: 0 }}
                  />
                  <Box
                    sx={{
                      fontFamily: 'monospace',
                      fontSize: '0.875rem',
                      color: 'text.primary',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      minWidth: 0,
                    }}
                  >
                    {this.state.pendingImportPayload.filename}
                  </Box>
                </Box>
              )}

              <DialogContentText sx={{ color: 'text.secondary', fontSize: '0.9rem' }}>
                Do you want to proceed with the re-import?
              </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
              <Button
                onClick={this.handleCancelReimport}
                sx={{
                  color: 'text.secondary',
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 2,
                  '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={this.handleConfirmReimport}
                variant="contained"
                autoFocus
                sx={{
                  bgcolor: '#005E73',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 2.5,
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: '#004a5c',
                    boxShadow: 'none',
                  },
                }}
              >
                Re-import
              </Button>
            </DialogActions>
          </Dialog>

          <ImportLogsDrawer
            open={this.state.logsDrawerOpen}
            onClose={() => this.setState({ logsDrawerOpen: false })}
            listImportLogs={this.props.listImportLogs}
            deleteImportLog={this.props.deleteImportLog}
            clearImportLogs={this.props.clearImportLogs}
            customFeedBackBar={this.props.customFeedBackBar}
          />
        </React.Fragment>
      );
    }
}

export default MarketplaceSummaryTable;
